export async function register(): Promise<void> {
  // ponytail: FCM disabled while firebaseWorker commented out — restore initForegroundMessaging when FCM returns
}

export function unregister(): void {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        if (registration.active?.scriptURL.includes("firebase-messaging-sw.js")) {
          void registration.unregister();
        }
      });
    });
  }
}
